var _defs, _rect, _rect2, _polygon, _rect3, _path, _path2, _rect4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _rect5, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _rect6, _rect7, _polygon2, _path29, _path30, _path31, _path32, _path33, _path34, _g, _path35, _path36, _path37, _path38, _g2, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _rect8, _polygon3, _path47, _rect9, _rect0, _rect1, _polygon4, _rect10, _rect11, _polygon5, _rect12, _path48, _rect13, _rect14, _polygon6, _rect15, _rect16, _polygon7, _rect17, _rect18, _polygon8, _rect19, _rect20, _polygon9, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _g3, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _polygon0, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _polyline, _g4, _path88, _path89, _polygon1, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _rect21, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _g5, _g6, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255 290",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1e1e1;}.cls-2{fill:#ececec;}.cls-3{fill:#fff;}.cls-4{fill:#f5f5f5;}.cls-5{fill:#53a8bc;}.cls-6{fill:#1a2e35;}.cls-7{fill:#375a64;}.cls-8{opacity:0.3;}.cls-9{fill:#08c29d;}.cls-10{fill:#ff735d;}.cls-11,.cls-15{fill:#021166;}.cls-12{opacity:0.6;}.cls-13{fill:#c27460;}.cls-14{fill:#7c4235;}.cls-15{font-size:11.61px;font-family:Inter-Bold, Inter;font-weight:700;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "banner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.62,
    y: 241.15,
    width: 34.19,
    height: 34.19,
    rx: 13.31
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.48,
    y: 241.15,
    width: 34.19,
    height: 34.19,
    rx: 13.31
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "7.77 258.74 11.21 255.29 17.86 261.2 28.95 250.06 32.14 253.51 17.36 267.84 7.77 258.74"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 17.49,
    y: 27.35,
    width: 130.68,
    height: 178.92,
    rx: 4.21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M243.19,38l.25,1.24L241,52.57h0a7.94,7.94,0,0,1-6.14,1.4L220.91,51.4s-2.21-.5-1.6-3.37c0,0,.11-1.52,1.41-1.62,0,0-2.7-1.09-2.4-3.17s1.83-2.05,1.83-2.05-2.53-.64-2.27-3,1.63-2.35,1.63-2.35-2.94-.71-2.2-3.31a2.67,2.67,0,0,1,3.26-2l9.91,1.83L239.16,34A5,5,0,0,1,243.19,38Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M240.74,34.6a17.41,17.41,0,0,1-4.13-5.76,15,15,0,0,1-.72-4.63l.35-2a1.33,1.33,0,0,0-1-1.52,4.36,4.36,0,0,0-4.82,3.19c-1.16,4-.17,6.71-.13,7.93l0,1.21Z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 240.57,
    y: 35.53,
    width: 9.89,
    height: 20.1,
    transform: "translate(478.66 135.02) rotate(-169.53)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M238.83,54.56s.78-4.43,1.78-9.89,1.85-9.88,1.87-9.88-.78,4.43-1.79,9.89S238.85,54.56,238.83,54.56Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.55,56.35s.78-4.43,1.79-9.88,1.84-9.88,1.87-9.88-.78,4.43-1.79,9.89S248.57,56.36,248.55,56.35Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M245.08,40a1.85,1.85,0,1,0,2.15-1.48A1.84,1.84,0,0,0,245.08,40Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.2,32s1.07.16,2.37.4,2.37.46,2.36.48-1.06-.16-2.37-.4S228.19,32,228.2,32Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.94,41.24s.68.09,1.52.24,1.51.3,1.5.32a13.93,13.93,0,0,1-1.52-.24A13.5,13.5,0,0,1,219.94,41.24Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.33,35.78s1,.14,2.16.36,2.14.41,2.14.43-1-.14-2.16-.36S219.33,35.8,219.33,35.78Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.11,46.33s1,.14,2.15.35,2.15.42,2.15.44-1-.14-2.16-.36S220.1,46.35,220.11,46.33Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M244.67,35.78s1.37.21,3,.52,3,.58,3,.6-1.37-.21-3-.52S244.67,35.8,244.67,35.78Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.81,39.2s0,0,0-.11a1.52,1.52,0,0,1-.06-.32,2.57,2.57,0,0,1,0-.49,2.66,2.66,0,0,1,.13-.58,2.38,2.38,0,0,1,.26-.53,1.81,1.81,0,0,1,.31-.38,1.06,1.06,0,0,1,.25-.21c.06,0,.1-.07.1-.06s-.13.11-.31.31a2,2,0,0,0-.29.37,3.26,3.26,0,0,0-.25.53,2.5,2.5,0,0,0-.13.56,2.63,2.63,0,0,0,0,.48C218.78,39,218.83,39.2,218.81,39.2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.3,33.93s-.1-.08-.19-.25a1.42,1.42,0,0,1-.18-.74,1.63,1.63,0,0,1,.2-.74c.11-.17.2-.25.21-.24s-.07.1-.16.27a1.68,1.68,0,0,0-.17.71,1.48,1.48,0,0,0,.15.72C218.24,33.83,218.31,33.92,218.3,33.93Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M219.54,44.87a.7.7,0,0,1-.27-.24,1.31,1.31,0,0,1-.28-.83,1.34,1.34,0,0,1,.3-.82.92.92,0,0,1,.28-.24s-.1.1-.23.27a1.38,1.38,0,0,0-.27.79,1.41,1.41,0,0,0,.24.8C219.44,44.78,219.55,44.86,219.54,44.87Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M220.65,49.93a.84.84,0,0,1-.19-.26,1.94,1.94,0,0,1-.18-.77,1.73,1.73,0,0,1,.18-.76,1.11,1.11,0,0,1,.18-.27s0,.11-.13.29a1.86,1.86,0,0,0-.15.74,2,2,0,0,0,.15.74C220.59,49.82,220.66,49.93,220.65,49.93Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M230.49,28.47a1.25,1.25,0,0,1-.07-.21c0-.08,0-.16-.06-.27a2.81,2.81,0,0,1-.06-.35,6.09,6.09,0,0,1-.08-.93,9.28,9.28,0,0,1,.07-1.14,6.7,6.7,0,0,1,.26-1.11,5.27,5.27,0,0,1,.34-.87,3.17,3.17,0,0,1,.16-.32c0-.09.09-.17.13-.23a1,1,0,0,1,.13-.19l-.1.2a2.68,2.68,0,0,0-.12.24c-.05.1-.1.2-.15.32a7.06,7.06,0,0,0-.32.87,8.11,8.11,0,0,0-.25,1.1,7.6,7.6,0,0,0-.08,1.13,7.88,7.88,0,0,0,.06.92c0,.13,0,.25.05.35s0,.2,0,.27A.89.89,0,0,1,230.49,28.47Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M228.13,159.75l.66.76,3.58,10.1h0a6.28,6.28,0,0,1-3.65,3.39l-10.57,3.75s-1.71.53-2.42-1.68c0,0-.53-1.08.32-1.67,0,0-2.28.32-2.9-1.22s.44-2.14.44-2.14a2.3,2.3,0,0,1-2.73-1.14c-.75-1.71.19-2.25.19-2.25s-2.3.67-2.82-1.4a2.11,2.11,0,0,1,1.46-2.63l7.52-2.67,6.58-2.33A4,4,0,0,1,228.13,159.75Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M225.11,158.39a13.77,13.77,0,0,1-5.11-2.32,11.7,11.7,0,0,1-2.33-2.89l-.57-1.53a1,1,0,0,0-1.31-.63,3.45,3.45,0,0,0-2,4.09,13.76,13.76,0,0,0,3,5.49l.51.82Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.81,
    y: 156.06,
    width: 7.83,
    height: 15.91,
    transform: "translate(506.87 240.87) rotate(160.48)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.69,172.82s-1.22-3.34-2.69-7.48-2.64-7.51-2.63-7.51,1.22,3.34,2.69,7.49S231.7,172.82,231.69,172.82Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M239.07,170.21s-1.22-3.35-2.69-7.49-2.64-7.5-2.63-7.51,1.22,3.35,2.69,7.49S239.08,170.2,239.07,170.21Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M230.2,160.34a1.46,1.46,0,1,0,.89-1.87A1.46,1.46,0,0,0,230.2,160.34Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.48,161.56s.79-.31,1.78-.66,1.81-.63,1.81-.61-.79.31-1.79.67S215.48,161.58,215.48,161.56Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.47,171.17a10.77,10.77,0,0,1,1.14-.44c.63-.22,1.15-.39,1.16-.38a10.35,10.35,0,0,1-1.14.44C214,171,213.48,171.18,213.47,171.17Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.89,167.66s.72-.29,1.62-.61,1.64-.56,1.64-.54-.72.28-1.62.6S210.9,167.68,210.89,167.66Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.6,174.59s.72-.29,1.62-.61,1.63-.57,1.64-.55-.72.29-1.62.61S215.6,174.6,215.6,174.59Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228.27,157.64s1-.4,2.29-.85,2.31-.8,2.31-.79-1,.4-2.29.85S228.27,157.65,228.27,157.64Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M211.89,170.21l-.07-.06a.83.83,0,0,1-.17-.19,1.7,1.7,0,0,1-.2-.33,2,2,0,0,1-.14-.45,2,2,0,0,1,0-.47,1.78,1.78,0,0,1,.06-.38c0-.11.06-.19.08-.25l.05-.08s0,.13-.09.34a1.84,1.84,0,0,0,0,.37,2.3,2.3,0,0,0,.17.9,2.45,2.45,0,0,0,.18.33C211.8,170.11,211.9,170.21,211.89,170.21Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M209.46,166.8s-.1,0-.24-.09a1.26,1.26,0,0,1-.41-.44,1.1,1.1,0,0,1-.15-.59.47.47,0,0,1,0-.24s0,.09,0,.24a1.37,1.37,0,0,0,.16.56,1.18,1.18,0,0,0,.39.43C209.37,166.76,209.46,166.79,209.46,166.8Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M214.64,173.82a1,1,0,0,1-.29-.06,1.16,1.16,0,0,1-.52-.46,1.06,1.06,0,0,1-.11-.69.74.74,0,0,1,.09-.27s0,.11-.05.28a1.1,1.1,0,0,0,.13.65,1.13,1.13,0,0,0,.48.45C214.53,173.79,214.64,173.8,214.64,173.82Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M217.4,176.84a.54.54,0,0,1-.23-.1,1.29,1.29,0,0,1-.43-.46,1.27,1.27,0,0,1-.18-.59.57.57,0,0,1,0-.26s0,.1,0,.25a1.47,1.47,0,0,0,.19.57,1.51,1.51,0,0,0,.4.45Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M215.65,158.24l-.13-.13-.15-.15a2.38,2.38,0,0,1-.18-.22,5.58,5.58,0,0,1-.42-.6,6.79,6.79,0,0,1-.4-.81,7.12,7.12,0,0,1-.27-.87c0-.27-.09-.52-.11-.73s0-.2,0-.28a.74.74,0,0,1,0-.21,1.49,1.49,0,0,1,0-.19,1.49,1.49,0,0,1,0,.19,1.7,1.7,0,0,0,0,.21c0,.08,0,.18,0,.28a6,6,0,0,0,.12.72,5.19,5.19,0,0,0,.27.85,6.12,6.12,0,0,0,.39.81,7.14,7.14,0,0,0,.41.61l.17.22.14.16C215.62,158.19,215.66,158.24,215.65,158.24Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 100.49,
    y: 231.69,
    width: 44.07,
    height: 44.07,
    rx: 13.31
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 92.58,
    y: 231.69,
    width: 44.07,
    height: 44.07,
    rx: 13.31
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "99.4 254.36 103.84 249.92 112.4 257.53 126.69 243.18 130.82 247.62 111.76 266.09 99.4 254.36"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M244.17,274.33c0,.09-52.64.15-117.55.15s-117.57-.06-117.57-.15,52.63-.15,117.57-.15S244.17,274.25,244.17,274.33Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.61,257.57s-2.44-16.77-2.24-26.52,0-20.73,0-20.73h1.12s-.76,19.36.07,31,3,16.21,3,16.21h-1.95"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M227.87,191.45a2.93,2.93,0,0,0-1-1.5,2.86,2.86,0,0,0-2.44,0c-3.4,1.2-6.41,7.53-7.78,10.86L221.14,216C229.27,208.47,230.68,198.57,227.87,191.45Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226.59,190.56a1.13,1.13,0,0,1-.07.2l-.22.56c-.2.47-.48,1.17-.81,2-.66,1.73-1.51,4.14-2.26,6.86s-1.27,5.22-1.59,7c-.16.91-.29,1.65-.36,2.16,0,.24-.07.43-.1.59a1.81,1.81,0,0,1,0,.2s0-.07,0-.21l.07-.59c0-.52.15-1.26.3-2.17a61.84,61.84,0,0,1,1.54-7.07,64.92,64.92,0,0,1,2.32-6.86c.35-.85.64-1.54.86-2l.26-.54A.73.73,0,0,1,226.59,190.56Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M219.13,219.66a13.78,13.78,0,0,1-6.95-11.55c-.16-3.37.88-6.68,2-9.84a1.25,1.25,0,0,1,.48-.72,1.22,1.22,0,0,1,1.15.18c3.07,1.75,4.93,5.09,5.92,8.48a17.18,17.18,0,0,1,.7,7,11.56,11.56,0,0,1-3.35,6.48"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M219.13,219.66s0-.07,0-.2v-.58c0-.51,0-1.24-.06-2.15a59.53,59.53,0,0,0-.78-7c-.47-2.72-1-5.16-1.46-6.92-.21-.86-.38-1.57-.5-2.09l-.13-.57c0-.13,0-.2,0-.2s0,.07.07.2.09.33.16.56c.14.48.33,1.19.56,2.07.45,1.75,1,4.19,1.51,6.92a51.09,51.09,0,0,1,.73,7c0,.91,0,1.64,0,2.15l0,.58A.8.8,0,0,1,219.13,219.66Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.13,219.66a13.78,13.78,0,0,1-6.95-11.55c-.16-3.37.88-6.68,2-9.84a1.25,1.25,0,0,1,.48-.72,1.22,1.22,0,0,1,1.15.18c3.07,1.75,4.93,5.09,5.92,8.48a17.18,17.18,0,0,1,.7,7,11.56,11.56,0,0,1-3.35,6.48"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M223.9,245.32c4.16.91,7.58,3.85,11.59,5.27,2.66.95,5.66,1.28,7.78,3.14a6.55,6.55,0,0,0-2.88-2.87,51.47,51.47,0,0,0-10.51-5c-1.89-.65-3.94-1.2-5.86-.66"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M217.89,249c-5.21-.08-10.7-4.51-15.88-4.78,5.42-1.75,13.19-.32,15.88,4.78"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M219.92,236.53a17,17,0,0,1,8.33-.57,51.18,51.18,0,0,1,8.13,2.21c-.27-1.8-1.73-3.16-3.11-4.37a22.62,22.62,0,0,0-3.26-2.51,7.29,7.29,0,0,0-3.92-1.1,6.22,6.22,0,0,0-4.32,2.18,7.2,7.2,0,0,0-1.85,4.16"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M209.23,230.78c-3.28-2.8-8.24-2.53-12.55-2.43a102.78,102.78,0,0,1,19.47,12.13C216.32,237.44,213.37,234.31,209.23,230.78Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.23,230.78c-3.28-2.8-8.24-2.53-12.55-2.43a102.78,102.78,0,0,1,19.47,12.13C216.32,237.44,213.37,234.31,209.23,230.78Z"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M221.4,226.91a37.25,37.25,0,0,1,5-2.93c1.72-.78,3.33-2,5-2.93a55.45,55.45,0,0,0,6-4.25,15.54,15.54,0,0,1,6.59-3.14,13,13,0,0,0-6,.34,39.45,39.45,0,0,0-5.64,2.2,27.41,27.41,0,0,0-7.25,4.2c-2.1,1.87-4,3.72-3.76,6.51"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M235.4,249s-.06,0-.17-.07l-.45-.23c-.39-.21-1-.52-1.66-.88-.36-.18-.74-.38-1.17-.57s-.87-.42-1.35-.62a19.75,19.75,0,0,0-3.21-1.12,6.91,6.91,0,0,0-3.34-.09,9.78,9.78,0,0,0-1.41.43,7.26,7.26,0,0,0-1.15.58,7.41,7.41,0,0,0-1.43,1.19c-.3.32-.45.52-.46.51s0-.06.09-.15.17-.24.31-.41a7,7,0,0,1,1.42-1.25,7.84,7.84,0,0,1,1.16-.62,10.47,10.47,0,0,1,1.43-.44,7,7,0,0,1,3.43.07,18.76,18.76,0,0,1,3.23,1.14c.48.21.94.42,1.35.64s.81.4,1.16.6c.7.37,1.25.7,1.64.92l.43.27Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M214,246.44a1.68,1.68,0,0,1,.33.1,6.85,6.85,0,0,1,.85.37,10,10,0,0,1,2.48,1.76,10.27,10.27,0,0,1,1.87,2.42,7.25,7.25,0,0,1,.4.83,1.46,1.46,0,0,1,.11.32s-.23-.42-.63-1.09a11.53,11.53,0,0,0-1.87-2.34,12.19,12.19,0,0,0-2.43-1.79C214.44,246.65,214,246.47,214,246.44Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M202.48,230.52a.63.63,0,0,1,.22.06l.62.23,1,.36c.38.14.8.35,1.27.56a29.8,29.8,0,0,1,6.78,4.32,31.33,31.33,0,0,1,5.41,6c.59.84,1,1.54,1.35,2l.36.56a1.23,1.23,0,0,1,.12.2.94.94,0,0,1-.15-.18l-.39-.54c-.32-.48-.79-1.17-1.4-2s-1.36-1.78-2.26-2.8a34.51,34.51,0,0,0-3.16-3.09,31.86,31.86,0,0,0-6.71-4.34c-.47-.22-.88-.43-1.26-.59l-1-.39-.61-.25Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M227.74,233.6a2.37,2.37,0,0,1-.42,0l-.48-.09a5.38,5.38,0,0,0-.64-.06,6.6,6.6,0,0,0-3.58.7,6.85,6.85,0,0,0-1.63,1.21,7,7,0,0,0-1,1.3,10.61,10.61,0,0,0-.72,1.36,1.57,1.57,0,0,1,.11-.4,5.17,5.17,0,0,1,.5-1,6.73,6.73,0,0,1,1-1.35,6.4,6.4,0,0,1,1.67-1.25,6.27,6.27,0,0,1,3.67-.67,5.37,5.37,0,0,1,.65.09l.48.12Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M233,217.36a.68.68,0,0,1-.2.12l-.58.32c-.5.27-1.23.67-2.11,1.19s-1.92,1.18-3,2a24.82,24.82,0,0,0-3.37,2.82,8.79,8.79,0,0,0-1.38,1.78c-.34.66-.66,1.29-1,1.9a31.3,31.3,0,0,0-1.45,3.29c-.35,1-.57,1.77-.71,2.32s-.18.88-.2.87l0-.23c0-.15,0-.37.1-.65a18.47,18.47,0,0,1,.65-2.35c.35-1,.83-2.1,1.42-3.33.3-.61.62-1.24,1-1.9a8.45,8.45,0,0,1,1.41-1.83,23.7,23.7,0,0,1,3.4-2.83c1.11-.79,2.16-1.42,3-1.94s1.63-.89,2.15-1.14l.6-.29Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M218.37,233.13a1.68,1.68,0,0,1-.11-.44c-.06-.32-.13-.72-.23-1.2a33.08,33.08,0,0,0-1-3.91,34.35,34.35,0,0,0-1.49-3.75l-.51-1.11a2.3,2.3,0,0,1-.16-.42,2.62,2.62,0,0,1,.23.39c.14.25.33.62.56,1.09a27.86,27.86,0,0,1,1.55,3.74,27,27,0,0,1,.93,3.95c.09.51.14.92.17,1.21A2.16,2.16,0,0,1,218.37,233.13Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M218,221.28a14.16,14.16,0,0,0-1.69-5.62,18.56,18.56,0,0,0-12.59-9.38q5.83,8.67,11.65,17.36l1.51,3.1A9,9,0,0,0,218,221.28Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 207.61,
    y: 255.5,
    width: 27.09,
    height: 4.8
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "209.63 259.35 211.94 274.24 229.92 274.24 232.68 259.35 209.63 259.35"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M234.68,260.3c0,.06-6.11.1-13.64.1s-13.65,0-13.65-.1,6.11-.09,13.65-.09S234.68,260.25,234.68,260.3Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 34.61,
    y: 234.73,
    width: 39.6,
    height: 39.6,
    rx: 13.31
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 34.61,
    y: 234.73,
    width: 39.6,
    height: 39.6,
    rx: 13.31
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 27.5,
    y: 234.73,
    width: 39.6,
    height: 39.6,
    rx: 13.31
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "33.62 255.1 37.61 251.11 45.31 257.95 58.16 245.05 61.86 249.04 44.74 265.64 33.62 255.1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 66.71,
    y: 249,
    width: 25.33,
    height: 25.33,
    rx: 8.23
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 62.16,
    y: 249,
    width: 25.33,
    height: 25.33,
    rx: 8.23
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "66.08 262.03 68.63 259.48 73.55 263.85 81.77 255.6 84.14 258.15 73.19 268.77 66.08 262.03"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 23.37,
    y: 19.54,
    width: 130.68,
    height: 178.92,
    rx: 4.21
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M149.84,198.46a4.21,4.21,0,0,0,1.53-.31,4.07,4.07,0,0,0,1.57-1.1,4.17,4.17,0,0,0,1.06-2.41c0-4.07,0-10.08,0-17.82,0-15.49,0-37.9-.05-65.58,0-13.84,0-29,0-45.28q0-12.21,0-25.23V24.18a4.2,4.2,0,0,0-1-3.05,4,4,0,0,0-2.85-1.44c-1.12,0-2.27,0-3.41,0H27.6a4.05,4.05,0,0,0-3.28,1.65,4,4,0,0,0-.74,1.74A17.57,17.57,0,0,0,23.52,25V78.79c0,19.93,0,39.14,0,57.45s0,35.7,0,52v6.05a4.07,4.07,0,0,0,3.45,4,9.93,9.93,0,0,0,1.45.06H60.22l65.57.05,17.83,0h4.64l1.58,0-1.58,0h-4.64l-17.83,0-65.57,0H28.4a9.23,9.23,0,0,1-1.48-.05,4.35,4.35,0,0,1-3.67-4.26v-6.05c0-16.28,0-33.68,0-52s0-37.52,0-57.45V25a14.8,14.8,0,0,1,.06-2,4.26,4.26,0,0,1,.79-1.87,4.41,4.41,0,0,1,3.53-1.78l119.09,0c1.14,0,2.27,0,3.43,0a4.36,4.36,0,0,1,3,1.54,4.54,4.54,0,0,1,1,3.23v3.36q0,6.69,0,13.19,0,13,0,25.23c0,16.27,0,31.44,0,45.28,0,27.68,0,50.09,0,65.58,0,7.74,0,13.75-.05,17.83a4.25,4.25,0,0,1-1.08,2.43,4.15,4.15,0,0,1-1.6,1.1,3.89,3.89,0,0,1-1.15.27Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.53,
    y: 72.75,
    width: 65.3,
    height: 7.73,
    rx: 3.71
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 43.58,
    y: 68.14,
    width: 17.91,
    height: 17.91,
    rx: 5.14
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "46.35 77.35 48.16 75.55 51.64 78.64 57.45 72.81 59.12 74.61 51.38 82.12 46.35 77.35"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.53,
    y: 100.53,
    width: 65.3,
    height: 7.73,
    rx: 3.71
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 43.58,
    y: 95.92,
    width: 17.91,
    height: 17.91,
    rx: 5.14
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "46.35 105.13 48.16 103.33 51.64 106.42 57.45 100.59 59.12 102.39 51.38 109.9 46.35 105.13"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.53,
    y: 128.31,
    width: 65.3,
    height: 7.73,
    rx: 3.71
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 43.58,
    y: 123.7,
    width: 17.91,
    height: 17.91,
    rx: 5.14
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "46.35 132.91 48.16 131.11 51.64 134.2 57.45 128.37 59.12 130.17 51.38 137.68 46.35 132.91"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 68.53,
    y: 156.09,
    width: 65.3,
    height: 7.73,
    rx: 3.71
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 43.58,
    y: 151.48,
    width: 17.91,
    height: 17.91,
    rx: 5.14
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "46.35 160.69 48.16 158.89 51.64 161.98 57.45 156.15 59.12 157.95 51.38 165.46 46.35 160.69"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M177.05,253.66l-.5,13.21s13.26,4.95,13.41,7.4l-25.65,0-.07-20.62Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.62,265.75a1,1,0,0,0-.72,1.19,1,1,0,0,0,1.17.73,1.11,1.11,0,0,0,.77-1.27,1.05,1.05,0,0,0-1.31-.62"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M164.31,274.22l.07-2.08L189,273s1.14.5,1,1.3Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M177,266.74c0,.13-.63.19-1.25.59s-.95.92-1.06.87.07-.77.83-1.24S177,266.63,177,266.74Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.66,267.86c0,.12-.52.34-.95.86s-.55,1.09-.67,1.09-.2-.72.34-1.36S179.65,267.74,179.66,267.86Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M181.18,271.09c-.12,0-.29-.6,0-1.29s.91-1,1-.85-.31.47-.56,1S181.3,271.07,181.18,271.09Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176.75,263.72c-.05.11-.63-.06-1.34,0s-1.26.27-1.32.16.46-.55,1.3-.6S176.81,263.62,176.75,263.72Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145.66,251.87l-1.39,15.93,2.53,12.92a1.64,1.64,0,0,1-1.4,1.94h0a1.62,1.62,0,0,1-1.41-.51c-2.29-2.49-10.65-11.71-10.48-12.87.19-1.34.35-16.9.35-16.9Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M145.4,282.66l-11.82-14.45-.05.67a2.52,2.52,0,0,0,.48,1.64c.94,1.25,3.6,4.67,9.93,11.63a1.66,1.66,0,0,0,1.46.51Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M137.18,263.27a1,1,0,0,1,.19,1.31,1,1,0,0,1-1.3.2,1.06,1.06,0,0,1-.19-1.39,1,1,0,0,1,1.37-.06"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.2,275.45a5.05,5.05,0,0,1,1.48-1.15,5,5,0,0,1,1.86-.23s-.18-.18-.55-.25a2.56,2.56,0,0,0-1.45.16,2.49,2.49,0,0,0-1.13.91C142.2,275.2,142.16,275.44,142.2,275.45Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M143.2,277.66c.07.08.62-.41,1.46-.59a14.39,14.39,0,0,1,1.57-.1,1.8,1.8,0,0,0-1.65-.24C143.62,276.94,143.12,277.62,143.2,277.66Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.26,272.58a16,16,0,0,1,2.19-1.07,15.31,15.31,0,0,1,2.4-.4,4.45,4.45,0,0,0-4.59,1.47Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.28,267.7c0,.1.94-.21,2.09-.18s2,.36,2.08.27a4.07,4.07,0,0,0-4.17-.09Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M140.56,263a8.42,8.42,0,0,1,2.18-.25,8.31,8.31,0,0,1,2.08.67s-.13-.24-.49-.48a3.53,3.53,0,0,0-1.56-.53,3.32,3.32,0,0,0-1.63.22C140.74,262.8,140.54,263,140.56,263Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.77,261.87a1.38,1.38,0,0,0,.06-.6,4.2,4.2,0,0,0-.38-1.61,1.91,1.91,0,0,0-.74-.94.66.66,0,0,0-.75.1,1.06,1.06,0,0,0-.3.7,2.31,2.31,0,0,0,1.89,2.27,2.69,2.69,0,0,0,2.72-1.23.94.94,0,0,0,.1-.77.67.67,0,0,0-.66-.39,2.2,2.2,0,0,0-1.08.48,4.72,4.72,0,0,0-1.17,1.17,1.38,1.38,0,0,0-.28.54,7.11,7.11,0,0,1,1.58-1.5,2.19,2.19,0,0,1,1-.4.35.35,0,0,1,.36.21.68.68,0,0,1-.09.5,2.4,2.4,0,0,1-2.38,1,2,2,0,0,1-1.63-1.9.8.8,0,0,1,.19-.5.35.35,0,0,1,.41-.06,1.64,1.64,0,0,1,.64.78A6.57,6.57,0,0,1,142.77,261.87Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M189.41,142.3a57,57,0,0,1,1.24,16.7c-.27,3.55-12.25,101.75-12.25,101.75H162.22l4.55-92.29-1.32.28s-8.83,39.37-9.55,45.74c-.65,5.73-8.1,47.35-8.1,47.35L133,262,137.74,207l5.5-52.82,2.06-15.38Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M166.18,162.2a.84.84,0,0,0,.11.11,1.3,1.3,0,0,0,.39.18,1.83,1.83,0,0,0,1.53-.36,3,3,0,0,0,1-2.09c.12-.88.14-1.82.2-2.82.11-2,.19-3.81.23-5.12a14.27,14.27,0,0,0,0-2.13,13.08,13.08,0,0,0-.23,2.12c-.1,1.3-.22,3.11-.32,5.11-.07,1-.08,2-.18,2.8a2.8,2.8,0,0,1-.89,1.95,1.77,1.77,0,0,1-1.37.42A3.33,3.33,0,0,1,166.18,162.2Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M142.39,152.7s.15.08.45.16a7.79,7.79,0,0,0,1.3.22,9.32,9.32,0,0,0,7.78-3.13,7.28,7.28,0,0,0,.78-1c.16-.26.23-.42.21-.43s-.4.55-1.16,1.33a10,10,0,0,1-3.47,2.35,10.2,10.2,0,0,1-4.13.71C143.06,152.82,142.4,152.65,142.39,152.7Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M183,148.59a5.61,5.61,0,0,0,.25,1.63,12.22,12.22,0,0,0,4.33,6.51,5.25,5.25,0,0,0,1.4.86,14.77,14.77,0,0,1-6-9Z"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "232.37 120.81 236.08 121.98 242.82 118.25 246.65 128.91 237.47 131.09 230.52 130.33 232.37 120.81"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.2,78s3.79,2.27,6.93,10c6.17,15.19,10,23.39,10,23.39l28.33,9-2.27,11.35s-28.7-4-32.55-5.44c-5.26-2-9.16-12.35-9.16-12.35Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M181.42,44a3,3,0,0,0,1-5.87,3.11,3.11,0,0,0-3-5.1,3.71,3.71,0,0,0-5.76-2.75,4.18,4.18,0,0,0-5.14.15,3,3,0,0,0-2.37,5.18"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M168,33.36l.66,0a12.67,12.67,0,0,1,13.2,11c.8,6.09,1.6,12.83,1.72,16.12.26,6.8-6.49,8.19-6.49,8.19l1,8.14-16.52.31-2.93-29.54C157.67,40.54,161,34.13,168,33.36Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M177.16,68.65a16.57,16.57,0,0,1-9-2.17s2.34,4.79,9.09,3.84Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M179.43,50.62a1,1,0,0,1-.89,1,.93.93,0,0,1-1-.82,1,1,0,0,1,.89-1A.93.93,0,0,1,179.43,50.62Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M180.57,47.74c-.11.14-.87-.37-1.92-.32s-1.78.62-1.9.5.05-.29.38-.55a2.62,2.62,0,0,1,1.51-.55,2.57,2.57,0,0,1,1.54.41C180.51,47.46,180.63,47.68,180.57,47.74Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M169.9,50.88a1,1,0,0,1-.89,1,.92.92,0,0,1-1-.82,1,1,0,0,1,.88-1A.94.94,0,0,1,169.9,50.88Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M170.32,48.45c-.12.13-.88-.38-1.92-.32s-1.79.61-1.91.49.06-.29.38-.55a2.65,2.65,0,0,1,1.52-.55,2.61,2.61,0,0,1,1.53.41C170.25,48.17,170.37,48.39,170.32,48.45Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M174.49,56a6.94,6.94,0,0,1,1.68-.4c.27,0,.52-.1.56-.29a1.45,1.45,0,0,0-.22-.78l-.89-2a36,36,0,0,1-2-5.22A33.24,33.24,0,0,1,176,52.38c.3.69.59,1.36.86,2a1.5,1.5,0,0,1,.19,1,.66.66,0,0,1-.42.41,2.23,2.23,0,0,1-.45.09A7.46,7.46,0,0,1,174.49,56Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M171,44.38c-.12.28-1,0-2.13,0s-2,.25-2.14,0,.13-.38.52-.61a3.4,3.4,0,0,1,1.64-.43,3.32,3.32,0,0,1,1.62.41C170.91,44,171.08,44.26,171,44.38Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M180.41,43.43c-.21.25-1.08,0-2.12.09s-1.9.25-2.12,0,0-.37.41-.61a3.6,3.6,0,0,1,3.41-.08C180.37,43.08,180.5,43.31,180.41,43.43Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M181.06,41.26s-2-4.17-4.1-5.06c-2.55-1.08-3.48,1.7-5.88,1.16s-4.83-1.58-7.16.37c-2.55,2.14-1.24,3.48-1.25,6.5-.06,12.26-2.12,15.83-3,10.1-.1-.62-1.88-1-2.27-3.69-.51-3.44-.85-7.63-.2-10.12a9.73,9.73,0,0,1,3.69-5.27c3.21-2.65,7.8-2.93,10.92-2.77S181.08,35.92,181.06,41.26Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M160.05,54.13A1.84,1.84,0,0,0,158,52.45c-1.26.18-2.63,1-2.42,3.59.38,4.63,5,3.3,5,3.16S160.23,56.07,160.05,54.13Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M159.35,57.54s-.07.06-.2.14a.84.84,0,0,1-.61.06A2,2,0,0,1,157.47,56a2.78,2.78,0,0,1,.13-1.17.93.93,0,0,1,.56-.67.41.41,0,0,1,.5.18c.07.12.05.22.07.22s.09-.08,0-.27a.51.51,0,0,0-.2-.28.64.64,0,0,0-.46-.08,1.16,1.16,0,0,0-.79.79,2.83,2.83,0,0,0-.17,1.32,2.11,2.11,0,0,0,1.34,1.9.86.86,0,0,0,.73-.18C159.36,57.65,159.37,57.55,159.35,57.54Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159.7,45.12a4.46,4.46,0,0,0,2,.81,1.52,1.52,0,0,0,1.63-1.15c0-.33-.06-.7.14-1s.71-.24,1.1-.22c1.36.08,2.86-1.49,3.14-2.82a1.21,1.21,0,0,0,1.64.25A4.11,4.11,0,0,0,170.43,40a1.93,1.93,0,0,1,1.56-.87,4.44,4.44,0,0,0,1,.17c.61-.09.87-.81.93-1.43s.1-1.32.6-1.67a2.46,2.46,0,0,1,1.66-.13c.56.06,1.28-.11,1.4-.67a1.11,1.11,0,0,0-.25-.83,3,3,0,0,0-3.61-1,4.08,4.08,0,0,0-7.53-.42A4.14,4.14,0,0,0,159.67,35a3,3,0,0,0-3.17,4.53,2.85,2.85,0,0,0-1.45,2.35A1.63,1.63,0,0,0,157,43.46a1.66,1.66,0,0,0,3,1.51"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M174.15,34.94s0,0,0,.08,0,.14,0,.25a2.8,2.8,0,0,1-.29.91,3.28,3.28,0,0,1-1,1.15A3.1,3.1,0,0,1,171,38l.08-.11a1.7,1.7,0,0,1,0,1.29,4.58,4.58,0,0,1-.74,1.18,3.57,3.57,0,0,1-.49.56,1.59,1.59,0,0,1-.73.31,1.71,1.71,0,0,1-1.52-.46l.17-.06a3.51,3.51,0,0,1-1.35,2.49,2.56,2.56,0,0,1-1.51.57,4.8,4.8,0,0,1-1.52-.25l.13-.06a3.77,3.77,0,0,1-1,1.49,2,2,0,0,1-1.6.52,2.57,2.57,0,0,1-2.07-1.91l.11,0a2.41,2.41,0,0,1-1.59.31,2.5,2.5,0,0,1-1.13-.44,2.33,2.33,0,0,1-.55-.54.74.74,0,0,1-.13-.24,2.62,2.62,0,0,0,.72.71,2.5,2.5,0,0,0,1.11.4,2.32,2.32,0,0,0,1.49-.33l.09-.05,0,.1a2.42,2.42,0,0,0,2,1.76,1.75,1.75,0,0,0,1.44-.49,3.43,3.43,0,0,0,1-1.41l0-.09.09,0a4.51,4.51,0,0,0,1.46.24,2.32,2.32,0,0,0,1.38-.53,3.37,3.37,0,0,0,1.29-2.35v-.22l.16.17a1.48,1.48,0,0,0,1.34.4,1.41,1.41,0,0,0,.64-.27,3.39,3.39,0,0,0,.47-.52,5,5,0,0,0,.72-1.13,1.49,1.49,0,0,0,0-1.17l0-.11H171a3,3,0,0,0,1.8-.59,3.26,3.26,0,0,0,1.35-2.29Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M174.44,59.59c0-.17-1.16.12-2.22-.63s-1.25-2-1.41-2-.15.32,0,.84a3,3,0,0,0,1.11,1.65,2.58,2.58,0,0,0,1.85.46C174.22,59.87,174.47,59.67,174.44,59.59Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202,102.55c-.1-.36-6.15-16.83-8.08-20.44a13.06,13.06,0,0,0-10.18-6.4c-3-.19-35.26,2.38-35.26,2.38s-9.63,2.16-10.85,10.44C136.23,98.07,135,119.9,135,119.9l14.68-7.52,1.9-4.79,30.37,6.78,7.41-11Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.37,79,159,73.48l1.41-5.43,14.7,7,3.08-3.4,1.29,3.83,3.22,1,7.53,13.25,0,28.22,1.52,24.34-1.63,3.84-13.49,2a15.08,15.08,0,0,1-4.45,0l-27.38-4.47-.7-8L147,113.44Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.38,68.05a36.53,36.53,0,0,1,5.87,2.73c4.13,2.2,8.83,4.22,8.83,4.22l-.35,6.64-15.65-7.86"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "178.16 71.59 175.08 75 176.73 82.11 179.47 75.68"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.14,75.73c.14.1,1,8.21,1,8.21l-15.68-9.47,14.28,7.17Z"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M175,106c-.23-6.2.75-22,.75-22l2-.33a230.6,230.6,0,0,1,5.24,34.24c.58,7.63.58,16.47.58,16.47l-4.1,8.81L175,134.4S175.32,113.54,175,106Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145.44,80s.42.38,1.06,1a13.07,13.07,0,0,1,2.09,2.86,12.75,12.75,0,0,1,1.23,3.32c.2.89.24,1.46.28,1.45a2,2,0,0,0,0-.4,8.48,8.48,0,0,0-.13-1.08,11.67,11.67,0,0,0-1.19-3.4,11.37,11.37,0,0,0-2.18-2.86,7.63,7.63,0,0,0-.83-.71A1.82,1.82,0,0,0,145.44,80Z"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "175.03 78.17 176.43 77.63 177.76 79.9 178 83.64 176.13 83.94 174.72 81.64 175.03 78.17"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M190.18,89.3c-.06,0-.11,8.1-.11,18.08s.05,18.09.11,18.09.11-8.1.11-18.09S190.24,89.3,190.18,89.3Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M174.93,74.94s.31.52.8,1.35a35.31,35.31,0,0,1,1.78,3.34l.15.32.1.21.1-.21a26.26,26.26,0,0,0,1.31-3.32c.13-.43.23-.78.29-1s.09-.38.07-.39a13.53,13.53,0,0,0-.5,1.37c-.31.84-.76,2-1.37,3.27h.2l-.15-.33a27.36,27.36,0,0,0-1.85-3.32c-.26-.41-.49-.73-.65-.95S175,74.93,174.93,74.94Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159,73.48l.21.13.64.33,2.34,1.21c2,1,4.67,2.49,7.66,4.09,1.82,1,3.55,1.87,5.05,2.62l.14.07v-.16l.05-4.77V75.65a3.06,3.06,0,0,0,0-.48,3.77,3.77,0,0,0,0,.48c0,.34,0,.79-.05,1.35,0,1.18-.07,2.82-.12,4.77l.14-.08c-1.49-.77-3.21-1.68-5-2.65-3-1.59-5.7-3-7.69-4l-2.37-1.15-.66-.29A.76.76,0,0,0,159,73.48Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188.29,78.59s.21.44.53,1.15a13.06,13.06,0,0,1,.9,2.89,12.74,12.74,0,0,1,.18,3c0,.78-.12,1.26-.08,1.26a1.32,1.32,0,0,0,.09-.33,5.64,5.64,0,0,0,.15-.92,11.07,11.07,0,0,0-1.1-6,8.5,8.5,0,0,0-.46-.8A1.75,1.75,0,0,0,188.29,78.59Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M176.47,84.19s.39-.12.8-.38.71-.5.68-.55-.39.11-.8.37S176.44,84.14,176.47,84.19Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M175.8,83.27a9.72,9.72,0,0,0,.95-1.89,10,10,0,0,0,.75-2,10.42,10.42,0,0,0-.95,1.89A10.87,10.87,0,0,0,175.8,83.27Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.79,80.42s-4.85,3.5-5.45,5.43-3.19,33.29-3.64,37-.91,10.7,2,13,9.1,4,9.1,4L151.51,128l-3-6.37,3-23.81Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M144.38,139.41l.31,0c.21,0,.51,0,.89-.06a6.58,6.58,0,0,0,3.11-1.12,8.48,8.48,0,0,0,3-4.06,18.43,18.43,0,0,0,1.12-6.38l0,.08-4.46-6.17,0-.05v-.06l.06-.5c.86-6.68,1.63-12.72,2.2-17.13.28-2.17.51-3.94.67-5.19.08-.59.14-1.06.19-1.41a4,4,0,0,1,.07-.5s0,0,0,.13,0,.21,0,.37c0,.35-.07.83-.13,1.42-.12,1.23-.32,3-.58,5.2-.51,4.4-1.25,10.46-2.11,17.15l-.06.5,0-.1c1.57,2.17,3.07,4.26,4.44,6.18l0,0v0a18.69,18.69,0,0,1-1.18,6.47,8.68,8.68,0,0,1-3.09,4.12,6,6,0,0,1-1.77.81l-.4.11-.37.07a4.22,4.22,0,0,1-.66.08,5.51,5.51,0,0,1-.9,0Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.52,123.79a5.22,5.22,0,0,1,1.27-.9,11.57,11.57,0,0,1,3.55-1.3,12,12,0,0,1,3.77-.13,5.26,5.26,0,0,1,1.52.37,17.07,17.07,0,0,0-5.23.06A17.24,17.24,0,0,0,138.52,123.79Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M176.59,92.57h0s.28,1,.72,2.88a12.93,12.93,0,0,1,3.75-3.58h0s7.49-7.45,9.88-15.27a38.07,38.07,0,0,0,1.31-12c-.07-.3-.66-3-1.13-5.15a3.41,3.41,0,0,1,2.47-4c3.72-1,13.79-3,16.1,3.8,3.44,10.1-2.13,21-2.07,24.12,0,.59,0,1.07,0,1.45,3-.68,5.24-1.17,5.26-1.12h0l19.39-4.53s6.41-1.93,8.61,4.63-5.26,8.76-5.26,8.76,3.51-.16,4.46,5.82-5.46,7.91-5.46,7.91,3.93-.25,4.94,5-5.41,8.26-5.76,8.42a15.1,15.1,0,0,1,1.55-.29,7.75,7.75,0,0,1-1.18.34c3,.38,3.42,3.94,3.42,3.94,1.93,7.3-3.69,8.83-3.69,8.83l-35.41,8.27a20.32,20.32,0,0,1-10.67-.39c.34,1.51.52,2.36.51,2.37h0l-24.73,5.77c-.06,0-2.73-11.22-6-25.1s-5.82-25.13-5.77-25.14Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M176.59,92.57h0s.28,1,.72,2.88a12.93,12.93,0,0,1,3.75-3.58h0s7.49-7.45,9.88-15.27a38.07,38.07,0,0,0,1.31-12c-.07-.3-.66-3-1.13-5.15a3.41,3.41,0,0,1,2.47-4c3.72-1,13.79-3,16.1,3.8,3.44,10.1-2.13,21-2.07,24.12,0,.59,0,1.07,0,1.45,3-.68,5.24-1.17,5.26-1.12h0l19.39-4.53s6.41-1.93,8.61,4.63-5.26,8.76-5.26,8.76,3.51-.16,4.46,5.82-5.46,7.91-5.46,7.91,3.93-.25,4.94,5-5.41,8.26-5.76,8.42a15.1,15.1,0,0,1,1.55-.29,7.75,7.75,0,0,1-1.18.34c3,.38,3.42,3.94,3.42,3.94,1.93,7.3-3.69,8.83-3.69,8.83l-35.41,8.27a20.32,20.32,0,0,1-10.67-.39c.34,1.51.52,2.36.51,2.37h0l-24.73,5.77c-.06,0-2.73-11.22-6-25.1s-5.82-25.13-5.77-25.14Z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M181.38,99.62l-.48,3.21,7.9,33.85h0a20.38,20.38,0,0,0,15.92,2.87l35.4-8.26s5.62-1.54,3.69-8.83c0,0-.46-3.88-3.8-4,0,0,6.79-3.14,5.77-8.43s-4.94-5-4.94-5,6.41-1.94,5.46-7.91-4.46-5.82-4.46-5.82,7.46-2.18,5.26-8.75-8.6-4.63-8.6-4.63l-25.19,5.87-22.07,5.16A13,13,0,0,0,181.38,99.62Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M187.26,90.59s7.49-7.44,9.88-15.27a38,38,0,0,0,1.31-12c-.07-.3-.66-3-1.13-5.16a3.41,3.41,0,0,1,2.47-4c3.72-1,10.43.84,12.74,7.61,3.45,10.09,1.23,17.18,1.29,20.3l.06,3.12Z"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 163.62,
    y: 93.5,
    width: 25.4,
    height: 51.6,
    transform: "translate(-22.51 43.22) rotate(-13.15)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M194.55,141.53s-2.53-11.27-5.77-25.14-5.91-25.12-6-25.11,2.53,11.27,5.77,25.15S194.5,141.54,194.55,141.53Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M169.82,147.31c.05,0-2.53-11.28-5.77-25.15s-5.91-25.11-6-25.1,2.52,11.27,5.77,25.15S169.77,147.32,169.82,147.31Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176.77,104.83a4.75,4.75,0,1,1-5.71-3.55A4.74,4.74,0,0,1,176.77,104.83Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M219.11,82.41s-2.72.53-6.05,1.31-6,1.45-6,1.5,2.72-.53,6.05-1.31S219.12,82.46,219.11,82.41Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M241.4,105.12c0-.05-1.74.31-3.87.81a39.49,39.49,0,0,0-3.83,1,35.5,35.5,0,0,0,3.88-.8A37.94,37.94,0,0,0,241.4,105.12Z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M242.3,91s-2.47.48-5.48,1.18-5.46,1.32-5.45,1.38,2.47-.48,5.49-1.18S242.31,91.09,242.3,91Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M241.57,118.18c0-.06-2.47.47-5.49,1.18s-5.45,1.32-5.44,1.37,2.47-.47,5.49-1.18S241.58,118.23,241.57,118.18Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M200,56.66a2.93,2.93,0,0,0-.57,2.94,19.5,19.5,0,0,0,1.35,2.85,10.7,10.7,0,0,1,.83,6.8,2.45,2.45,0,0,0,.11,2.06c.63.78,1.9.35,2.7-.27A10.11,10.11,0,0,0,208,60.82a7.1,7.1,0,0,0-2.49-4,4.2,4.2,0,0,0-5.47-.14"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M240.81,78.76a6.27,6.27,0,0,0-2.61.27l-14.95,3.8c-1.63.41-4.68.78-4.72,2.44h0a2,2,0,0,0,1.26,2.31,5.32,5.32,0,0,0,2.86.11c2-.32,4-.79,5.94-1.26A76.48,76.48,0,0,0,240.27,83a5.51,5.51,0,0,0,1.57-.88,2,2,0,0,0,.74-1.59A2.09,2.09,0,0,0,240.81,78.76Z"
  }))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M177.32,94.07s-3.48.71-7.74,1.71-7.71,1.84-7.7,1.9,3.48-.71,7.74-1.71S177.33,94.12,177.32,94.07Z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M244,99.76s.05-.1.1-.29a4.25,4.25,0,0,0,.13-.83,5.45,5.45,0,0,0,0-1.25,6.77,6.77,0,0,0-.39-1.48,7.08,7.08,0,0,0-.74-1.34,6.14,6.14,0,0,0-.83-.94,4.09,4.09,0,0,0-.66-.51,1,1,0,0,0-.28-.14s.35.26.85.75a8.1,8.1,0,0,1,.77.94,7,7,0,0,1,.7,1.31,7.29,7.29,0,0,1,.4,1.44,6.77,6.77,0,0,1,.09,1.21C244.1,99.33,244,99.75,244,99.76Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M244.72,86.18a1.82,1.82,0,0,0,.47-.67,4,4,0,0,0-.25-3.79,1.68,1.68,0,0,0-.55-.59s.19.24.43.67a4.31,4.31,0,0,1,.53,1.8,4.2,4.2,0,0,1-.29,1.86C244.88,85.91,244.69,86.16,244.72,86.18Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M242.85,114.39a1.89,1.89,0,0,0,.67-.66,3.36,3.36,0,0,0-.26-4.23,2,2,0,0,0-.74-.57s.28.22.63.66a3.65,3.65,0,0,1,.79,2,3.59,3.59,0,0,1-.54,2.08C243.1,114.13,242.83,114.36,242.85,114.39Z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M240.61,127.5a2.09,2.09,0,0,0,.44-.71,4.45,4.45,0,0,0-.17-3.92,2,2,0,0,0-.5-.66s.16.27.38.72a5.12,5.12,0,0,1,.47,1.89,5,5,0,0,1-.31,1.92C240.75,127.21,240.58,127.48,240.61,127.5Z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M212.8,73.64a2.3,2.3,0,0,0,.15-.57,6.39,6.39,0,0,0,.13-.68c0-.27.1-.57.12-.91a17.56,17.56,0,0,0,.09-2.39,19.93,19.93,0,0,0-.33-2.92,20.14,20.14,0,0,0-.78-2.82,17.19,17.19,0,0,0-1-2.19c-.15-.3-.31-.56-.45-.8s-.26-.42-.37-.58c-.22-.31-.34-.48-.35-.48a3.13,3.13,0,0,0,.28.52c.1.16.22.36.35.6s.28.5.42.81a19.09,19.09,0,0,1,1.69,5,22.43,22.43,0,0,1,.34,2.88,19.89,19.89,0,0,1-.05,2.38c0,.33-.06.64-.09.9s-.06.5-.09.69A4.68,4.68,0,0,0,212.8,73.64Z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M156.34,132.93a8,8,0,0,1,3.39-1.57c1.44-.07,3.32.5,3.7.31s1.25-1,1.82-.32,1.25,3.21-1.76,3.9h-2.07a10.06,10.06,0,0,0,.75,2.88c.51.82,7.53,9.66,7.53,9.66s.88.88.44,1.76-2.32.38-2.32.38a3,3,0,0,1-2.82.62,10.48,10.48,0,0,1-2.14-1,2.78,2.78,0,0,1-3.38,0c-1.76-1.32-7.62-8.66-7.62-8.66l2.1-8.22Z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M150.24,128.07l6.1,4.86-4.48,8-8.93-3.24S143.19,128.24,150.24,128.07Z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M245.34,117.22s-.19-2.18-1.41-1.73-1.73,3-1.73,3Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M241,119.38a6.92,6.92,0,0,1,5.07-2.19c3,.2,1.09,2.7,1.09,2.7s2.19,1.35.58,3.28l-.26.51s1.87.71-.06,2.7a1.94,1.94,0,0,1-.26,2.24c-1,1-3.37-.32-3.37-.32s-2.21.52-2.41-.38a1.71,1.71,0,0,1,.52-1.67c.19-.13,1.35-.58,1.35-.58s-2.57.32-2.64-.32-.32-1.35,1.61-2l1-.28s-2.67.09-2.68-.56-.15-.9.81-1.34a14,14,0,0,0,1.74-1S240.59,120.73,241,119.38Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M240.51,121.88a11.51,11.51,0,0,1,3.17-1.62,11.21,11.21,0,0,1,3.56-.28,2.75,2.75,0,0,0-1.05-.22,7.25,7.25,0,0,0-2.58.24,7.32,7.32,0,0,0-2.33,1.14A3,3,0,0,0,240.51,121.88Z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M240.8,125.56s-.06-.08-.12-.23a1.07,1.07,0,0,1,0-.67,1.55,1.55,0,0,1,.59-.81,3.47,3.47,0,0,1,1.17-.49,26,26,0,0,1,3.37-.4,3.1,3.1,0,0,0-1-.11,10,10,0,0,0-2.42.26,3.21,3.21,0,0,0-1.26.55,1.68,1.68,0,0,0-.62,1,1,1,0,0,0,.09.77C240.69,125.53,240.8,125.57,240.8,125.56Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M241.88,128.38s-.09-.06-.22-.18a1,1,0,0,1-.32-.65,1.06,1.06,0,0,1,.38-1A4.33,4.33,0,0,1,243,126a8.35,8.35,0,0,1,2.57-.14,3,3,0,0,0,1.1-.06,9.84,9.84,0,0,0-1.09-.12,7.1,7.1,0,0,0-2.66.06,4.2,4.2,0,0,0-1.34.66,1.13,1.13,0,0,0-.38.57,1.48,1.48,0,0,0,0,.59,1,1,0,0,0,.44.71C241.76,128.39,241.88,128.39,241.88,128.38Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M240.94,119.48s.06-.08.19-.2a5.23,5.23,0,0,1,.58-.48,8.57,8.57,0,0,1,2.18-1.17,5.67,5.67,0,0,1,2.42-.35c.63.1,1,.33,1,.28a1.73,1.73,0,0,0-1-.46,5,5,0,0,0-2.54.28C241.89,118.07,240.78,119.39,240.94,119.48Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-15",
    transform: "translate(48.41 44.72)"
  }, "ASSESSMENT")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/Assessment.610bc6b3a842178d9d31b0bdcd6d6749.svg";
export { ForwardRef as ReactComponent };